import { createTeamApi } from '@trackly/shared';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Single Team API instance for the web client — endpoint definitions live in
 * @trackly/shared (createTeamApi); only the authenticated baseQuery is web-specific.
 */
export const teamApi = createTeamApi(createAuthenticatedBaseQuery(apiBaseUrl, 'Team API'));
